export type SocialNetwork =
  | 'instagram'
  | 'facebook'
  | 'twitter'
  | 'linkedin'
  | 'tiktok'
  | 'threads'
  | 'gbp'
  | 'bluesky'
  | 'youtube'
  | 'pinterest'
  | 'telegram';

export const SOCIAL_NETWORKS: Record<SocialNetwork, { label: string; maxLength?: number }> = {
  instagram: { label: 'Instagram', maxLength: 2200 },
  facebook: { label: 'Facebook', maxLength: 63206 },
  twitter: { label: 'Twitter/X', maxLength: 280 },
  linkedin: { label: 'LinkedIn', maxLength: 3000 },
  tiktok: { label: 'TikTok', maxLength: 2200 },
  threads: { label: 'Threads', maxLength: 500 },
  gbp: { label: 'Google Business Profile', maxLength: 1500 },
  bluesky: { label: 'Bluesky', maxLength: 300 },
  youtube: { label: 'YouTube', maxLength: 5000 },
  pinterest: { label: 'Pinterest', maxLength: 500 },
  telegram: { label: 'Telegram', maxLength: 4096 },
};
